import React from "react";
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import {ubicacionesResources} from "../endpoints";
import useToken from "../useToken";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {InputLabel} from "@mui/material";
import {FormControl} from "@material-ui/core";

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            isNumericString
            prefix=""
        />
    );
}

NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

class DialogAgregarEditarUbicacion extends React.Component{
    constructor(props) {
        super(props);
        if(props.ubicacion === null){
            this.state = {
                iniciar: true,
                nivel: null,
                descripcion: "",
                padre: this.props.padre,
                comentarios:"",
                comentario_rango:"",
                editar: false,
                inicial: false,
                tag_inicial: "",
                tag_final: "",
            };
        }
        else{
            let comentario_rango = props.ubicacion.comentario_rango;
            let comentarios = props.ubicacion.comentarios;
            if(comentario_rango === null){
                comentario_rango = "";
            }
            if(comentarios === null){
                comentarios = "";
            }

            this.state = {
                iniciar: true,
                tag_inicial: props.ubicacion.tag_inicial,
                tag_final: props.ubicacion.tag_final,
                nivel: props.ubicacion.nivel,
                descripcion: props.ubicacion.descripcion,
                padre: props.ubicacion.padre,
                comentarios: comentarios,
                comentario_rango: comentario_rango,
                editar:true,
                idUbicacion: props.ubicacion.id,
                idRango:props.ubicacion.id_rango,
                inicial:props.ubicacion.inicial
            };
        }
    };

    handleChange = e =>{
        this.setState({[e.target.name]: e.target.value.replace("/", "") })
    }

    handleClick = () =>{
        let ubicacion_rango;
        if(!this.state.tag_final){
            ubicacion_rango = {
                tag_inicial: this.state.tag_inicial,
                tag_final: this.state.tag_inicial,
                nivel: this.state.nivel,
                descripcion: this.state.descripcion,
                padre: this.state.padre,
                comentarios: this.state.comentarios,
                comentario_rango: this.state.comentario_rango,
                inicial:this.state.inicial
            };
        }
        else{
            ubicacion_rango = this.state
        }

        if(!this.state.editar){
            ubicacionesResources.agregarUbicacionRango(ubicacion_rango).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result=> {
                if(result.message){
                    this.setState = {
                        iniciar: true,
                        nivel: null,
                        descripcion: "",
                        padre: this.props.padre,
                        comentarios:"",
                        editar: false,
                        tag_inicial: "",
                        tag_final: "",
                        comentario_rango:""
                    };
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else{
            ubicacionesResources.editarUbicacionRango(this.state.idUbicacion, this.state.idRango , this.state).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result=> {
                if(result.message){
                    this.setState = {
                        iniciar: true,
                        nivel: null,
                        descripcion: "",
                        padre: this.props.padre,
                        comentarios:"",
                        editar: false,
                        tag_inicial: "",
                        tag_final: "",
                        comentario_rango:""
                    };
                    this.props.refrescar(result.message,result.severity)
                }else{
                    throw new Error('Something went wrong ...');
                }

            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }

    }

    getEventType = (event) =>{
        if(!this.state.editar) {
            if (event.keyCode === 13) {
                if (this.state.descripcion && this.state.tag_inicial) {
                    this.handleClick()
                }
            } else if (event.keyCode === 27) {
                this.props.handleClose()
            }
        }
        else{
            if (event.keyCode === 13) {
                if (this.state.descripcion && this.state.tag_inicial && this.state.tag_final) {
                    this.handleClick()
                }
            } else if (event.keyCode === 27) {
                this.props.handleClose()
            }
        }
    }
    componentDidMount(){
        document.addEventListener('keyup', this.getEventType, false);    // third
        let datos_inv = useToken.getDatos()
        this.setState({cliente:datos_inv.app}, ()=>{

        })
        if (datos_inv.app === 'walmart_flejes' && this.state.padre === 1 ){
            this.setState({ opciones: [
                    'BUENOS DISPONIBLES']})
        }
        else if (datos_inv.app === 'walmart_flejes' && this.state.padre === 2) {
            this.setState({ opciones: [
                    'BUENOS CONECTADOS',
                    'BUENOS DISPONIBLES',
                    'BUENOS NO DISPONIBLES',
                    'MALOS',
                    'NUEVOS']})
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.getEventType, false);
    }

    render() {
        return(
            <Dialog
                open={this.state.iniciar}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        {this.state.cliente !== 'walmart_flejes' ?
                        <Grid item xs={12}>
                            <TextField type={'text'} autoFocus={true} value={this.state.descripcion} name="descripcion" label="Descripción" fullWidth onChange={this.handleChange}/>
                        </Grid>:null}
                        {this.state.cliente === 'walmart_flejes' ?
                            <Grid item xs={12}>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel id="demo-simple-select-outlined-label">Descripción</InputLabel>
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    name="descripcion"
                                    value={this.state.descripcion}
                                    onChange={this.handleChange}
                                    label="Age"
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    {this.state.opciones.map((opcion, index) => (
                                        <MenuItem key={index} value={opcion}>
                                            {opcion}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>:null}
                        <Grid item  xs={12}>
                            <TextField value={this.state.comentarios} name="comentarios" label="Comentario ubicación" fullWidth onChange={this.handleChange}/>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label="Tag inicial"
                                onChange={this.handleChange}
                                value={this.state.tag_inicial}
                                name="tag_inicial"
                                fullWidth
                                InputProps={{
                                    inputComponent: NumberFormatCustom,
                                }}
                            />
                        </Grid>
                        <Grid item  xs={6}>
                            <TextField
                                onChange={this.handleChange}
                                label="Tag final"
                                name="tag_final"
                                value={this.state.tag_final}
                                fullWidth
                                InputProps={{
                                    inputComponent: NumberFormatCustom,
                                }}
                            />
                        </Grid>
                        <Grid item  xs={12}>
                            <TextField value={this.state.comentario_rango} name="comentario_rango" label="Comentario rango" fullWidth onChange={this.handleChange}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button disabled={!this.state.descripcion || !this.state.tag_inicial} variant="contained"  color="primary" onClick={this.handleClick}>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogAgregarEditarUbicacion;